import { forwardRef } from 'react';
import {
  FormHelperText,
  MenuItem,
  Select,
  SelectProps,
  styled,
} from '@mui/material';

type Props = SelectProps & {
  options: Array<{ value?: string; label: string; disabled?: boolean }>;
  placeholder?: string;
  errorMessage?: string;
};

const Placeholder = styled('p')(({ theme }) => ({
  color: theme.palette.text.hint,
}));

const AppSimpleSelect = forwardRef<HTMLDivElement, Props>(
  (
    {
      options = [],
      placeholder = 'Select',
      value = '',
      errorMessage,
      error,
      ...rest
    },
    ref,
  ) => {
    return (
      <>
        <Select
          displayEmpty
          native={false}
          renderValue={() =>
            value ? (
              options.find((option) => option.value === value)?.label
            ) : (
              <Placeholder>{placeholder}</Placeholder>
            )
          }
          ref={ref}
          value={value}
          {...rest}
        >
          {options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {error && errorMessage && (
          <FormHelperText error>{errorMessage}</FormHelperText>
        )}
      </>
    );
  },
);

export default AppSimpleSelect;
